import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import { USER_TYPES } from '../../../services/user';
import { QuestionnaireTypes } from '../../../services/questionnaires';
import { FEATURE_FLAGS, useFeatureFlagState } from '../../../hooks/useFeatureFlag';
import { isWorkspaceCoveredStatus } from './workspaceDerivations';

// v2 applies only when the assessor-experience flag is on, under /assessment/:assessmentId for assessors/TPN admins on the MPA Best Practice questionnaire during Assessing/Submitted; everyone else keeps the existing UI.
export function useAssessmentVariant(): boolean {
  const params = useParams();
  const { user } = useAppSelector(state => state.user);
  const { questionnaire, assessmentStatus } = useAppSelector(state => state.questionnaireAnswer);
  const { enabled: flagEnabled } = useFeatureFlagState(FEATURE_FLAGS.V2_ASSESSOR_EXPERIENCE);

  if (!flagEnabled) return false;
  if (!params.assessmentId) return false;
  if (user?.type !== USER_TYPES.ASSESSOR && user?.type !== USER_TYPES.TPN_ADMIN) return false;
  if (!isWorkspaceCoveredStatus(assessmentStatus)) return false;
  return !questionnaire || questionnaire.type === QuestionnaireTypes.MPA_BEST_PRACTICE;
}


// True while the variant decision's inputs load — callers hold the classic chrome (never render the workspace early).
export function useAssessmentVariantPending(): boolean {
  const params = useParams();
  const { user } = useAppSelector(state => state.user);
  const { assessmentStatus } = useAppSelector(state => state.questionnaireAnswer);
  const { enabled: flagEnabled, loaded: flagLoaded } = useFeatureFlagState(FEATURE_FLAGS.V2_ASSESSOR_EXPERIENCE);

  if (!params.assessmentId) return false;
  if (user?.type !== USER_TYPES.ASSESSOR && user?.type !== USER_TYPES.TPN_ADMIN) return false;
  // A flag still fetching could flip the layout once resolved; hold until it settles.
  if (!flagLoaded) return true;
  if (!flagEnabled) return false;
  return !assessmentStatus;
}
